export enum MediaFileTypesEnum {
  IMAGE = 'image',
  AUDIO = 'audio'
}
